import * as React from 'react';
import { st, classes } from './ThreeDotsLoader.deprecated.st.css';
/** Animated loader element made from three pulsating dots */
export class ThreeDotsLoader extends React.Component {
    render() {
        const { className, isStatic, 'aria-hidden': ariaHidden } = this.props;
        const isAriaHidden = ariaHidden && ariaHidden !== 'false';
        return (React.createElement("div", { "data-hook": this.props['data-hook'], className: st(classes.root, { static: !!isStatic }, className), "aria-hidden": isAriaHidden },
            React.createElement("div", { className: classes.dots })));
    }
}
ThreeDotsLoader.displayName = 'ThreeDotsLoader';
//# sourceMappingURL=ThreeDotsLoader.js.map